import React, { useEffect } from 'react';
import './Help.css';
import { FaQuestionCircle, FaEnvelope, FaPhone, FaClock } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

function Help() {
  const { t, i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.setAttribute('lang', i18n.language);
  }, [i18n.language]);

  const faqs = [
    {
      question: t("help.question1"),
      answer: t("help.answer1")
    },
    {
      question: t("help.question2"),
      answer: t("help.answer2")
    },
    {
      question: t("help.question3"),
      answer: t("help.answer3")
    },
    {
      question: t("help.question4"),
      answer: t("help.answer4")
    }
  ];

  return (
    <div className="help-container">
      <div className="help-section">
        <h3 className="help-section-title">
          <FaQuestionCircle /> {t("help.FAQ")}
        </h3>
        {faqs.map((faq, index) => (
          <div className="faq-item" key={index}>
            <div className="faq-question">{faq.question}</div>
            <div className="faq-answer">{faq.answer}</div>
          </div>
        ))}
      </div>

      <div className="help-section">
        <h3 className="help-section-title">
          <FaEnvelope /> {t("help.contactSupport")}
        </h3>
        <div className="contact-info">
          <div className="contact-item">
            <FaEnvelope />
            <div>
              <div>{t("help.emailSupport")}</div>
              <div className="contact-details">support@eztimesheet.com</div>
            </div>
          </div>
          <div className="contact-item">
            <FaPhone />
            <div>
              <div>{t("help.phoneSupport")}</div>
              <div className="contact-details">1-800-555-0123</div>
            </div>
          </div>
          <div className="contact-item">
            <FaClock />
            <div>
              <div>{t("help.supportHours")}</div>
              <div className="contact-details">Mon-Fri, 9AM-5PM EST</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Help; 